var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-form-product" }, [
    _c("div", { staticClass: "modal-form-product__icon" }, [
      _c("img", {
        staticClass: "modal-form-product__img",
        attrs: { src: _vm.baseUrl + _vm.product.thumbnail },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-form-product__content" }, [
      _c("div", { staticClass: "modal-form-product__name" }, [
        _vm._v("\n      " + _vm._s(_vm.product.name) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-form-product__price-area" }, [
        _c("div", { staticClass: "modal-form-product__price" }, [
          _vm._v(
            _vm._s(_vm.formatNumberWithSpaces(_vm.product.price.toFixed(0))) +
              " руб."
          ),
        ]),
        _vm._v(" "),
        _vm.product.profit
          ? _c("div", { staticClass: "modal-form-product__price-raw" }, [
              _vm._v(
                _vm._s(
                  _vm.formatNumberWithSpaces(_vm.product.price_raw.toFixed(0))
                ) + " руб."
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }